/** Maps API errorCode (CFE*) to common.json feedbackCodes keys. */
export const ACTIVITY_DEPENDENCY_ERROR_CODE_TO_KEY: Record<string, string> = {
  CFE000038: 'ACTIVITY_DEPENDENCY_NOT_SCHEDULED',
  CFE000039: 'ACTIVITY_DEPENDENCY_SCHEDULE_ORDER',
  CFE000040: 'ACTIVITY_DEPENDENCY_SAME_PROJECT',
  CFE000041: 'ACTIVITY_DEPENDENCY_SELF',
  CFE000042: 'ACTIVITY_DEPENDENCY_CYCLE',
  CFE000043: 'ACTIVITY_DEPENDENCY_NOT_FOUND',
  CFE000044: 'ACTIVITY_DEPENDENCY_MIN_DAYS',
};

export function getActivityDependencyFeedbackKey(
  error: unknown
): string | undefined {
  const err = error as { errorCode?: string; message?: string };
  if (err?.errorCode && ACTIVITY_DEPENDENCY_ERROR_CODE_TO_KEY[err.errorCode]) {
    return ACTIVITY_DEPENDENCY_ERROR_CODE_TO_KEY[err.errorCode];
  }
  if (
    err?.message &&
    Object.values(ACTIVITY_DEPENDENCY_ERROR_CODE_TO_KEY).includes(err.message)
  ) {
    return err.message;
  }
  return undefined;
}
